import { render, staticRenderFns } from "./StorageDataTable.vue?vue&type=template&id=3b70155c&"
import script from "./StorageDataTable.ts?vue&type=script&lang=ts&"
export * from "./StorageDataTable.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports